var map = {
	"./ion-action-sheet.entry.js": [
		499,
		6
	],
	"./ion-alert.entry.js": [
		500,
		7
	],
	"./ion-app_8.entry.js": [
		501,
		8
	],
	"./ion-avatar_3.entry.js": [
		502,
		18
	],
	"./ion-back-button.entry.js": [
		503,
		19
	],
	"./ion-backdrop.entry.js": [
		504,
		43
	],
	"./ion-button_2.entry.js": [
		505,
		20
	],
	"./ion-card_5.entry.js": [
		506,
		21
	],
	"./ion-checkbox.entry.js": [
		507,
		22
	],
	"./ion-chip.entry.js": [
		508,
		23
	],
	"./ion-col_3.entry.js": [
		509,
		44
	],
	"./ion-datetime_3.entry.js": [
		510,
		11
	],
	"./ion-fab_3.entry.js": [
		511,
		24
	],
	"./ion-img.entry.js": [
		512,
		45
	],
	"./ion-infinite-scroll_2.entry.js": [
		513,
		46
	],
	"./ion-input.entry.js": [
		514,
		25
	],
	"./ion-item-option_3.entry.js": [
		515,
		26
	],
	"./ion-item_8.entry.js": [
		516,
		27
	],
	"./ion-loading.entry.js": [
		517,
		28
	],
	"./ion-menu_3.entry.js": [
		518,
		29
	],
	"./ion-modal.entry.js": [
		519,
		9
	],
	"./ion-nav_2.entry.js": [
		520,
		15
	],
	"./ion-popover.entry.js": [
		521,
		10
	],
	"./ion-progress-bar.entry.js": [
		522,
		30
	],
	"./ion-radio_2.entry.js": [
		523,
		31
	],
	"./ion-range.entry.js": [
		524,
		32
	],
	"./ion-refresher_2.entry.js": [
		525,
		12
	],
	"./ion-reorder_2.entry.js": [
		526,
		17
	],
	"./ion-ripple-effect.entry.js": [
		527,
		47
	],
	"./ion-route_4.entry.js": [
		528,
		33
	],
	"./ion-searchbar.entry.js": [
		529,
		34
	],
	"./ion-segment_2.entry.js": [
		530,
		35
	],
	"./ion-select_3.entry.js": [
		531,
		36
	],
	"./ion-slide_2.entry.js": [
		532,
		48
	],
	"./ion-spinner.entry.js": [
		533,
		14
	],
	"./ion-split-pane.entry.js": [
		534,
		49
	],
	"./ion-tab-bar_2.entry.js": [
		535,
		37
	],
	"./ion-tab_2.entry.js": [
		536,
		16
	],
	"./ion-text.entry.js": [
		537,
		38
	],
	"./ion-textarea.entry.js": [
		538,
		39
	],
	"./ion-toast.entry.js": [
		539,
		40
	],
	"./ion-toggle.entry.js": [
		540,
		13
	],
	"./ion-virtual-scroll.entry.js": [
		541,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 344;
module.exports = webpackAsyncContext;